import { render, staticRenderFns } from "./UnarchiveRecordingDialog.vue?vue&type=template&id=57a5d0c6&scoped=true"
import script from "./UnarchiveRecordingDialog.vue?vue&type=script&lang=js"
export * from "./UnarchiveRecordingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5d0c6",
  null
  
)

export default component.exports